// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.single-tool[data-v-e3e9dad4] {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #999;\n    background-color: #bcbcbc;\n    height: 25px;\n    width: 25px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n            user-select: none;\n}\n.icon[data-v-e3e9dad4] {\n    font-size: 1.3em;\n}\n.icon[data-v-e3e9dad4]:hover {\n    color: #555;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
